module.exports = __webpack_public_path__ + "static/media/Wounds.4c86dbfb.svg";